export const SHOP_URL = "https://2gthr-co.myshopify.com/";
export const defaultPostsCount = 24;
export const notFoundImageUrl = "https://firebasestorage.googleapis.com/v0/b/gthr-dev.appspot.com/o/posts%2Fimage_not_found.png?alt=media&token=1777750e-7de5-480e-bbb6-829f483f8820";
export const regexPromoCodeErrorMessage = "That is a 2GTHR Promo Code, please use text field above";
export const appleStore = "https://apps.apple.com/si/app/2gthr/id1568467921";
export const googleStore = "https://play.google.com/store/apps/details?id=co.two_gthr.mobile&hl=en&gl=US";
